import { useSignals } from '@preact/signals-react/runtime'
import { GamelessGrid } from '../GamelessGrid/GamelessGrid'
import { useWebContainer } from '../../providers/DepProvider/DepProvider'

export function GamelessContainer() {
  useSignals()

  const container = useWebContainer()
  const vm = container.mateListVM

  return (
    <GamelessGrid
      mateListVM={vm}
      onOurMateClick={() => { container.localMatesSystem.localMates.showNameDialog.value = true }}
    />
  )
}
